(() => {
  const DeliveryInfo = () => {
    document.addEventListener('variant:change', (e) => {
      //console.log(e.detail);
      if (!e.detail.form) return;

      let $form = e.detail.form;
      let product_id = e.detail.product.id;
      let variant_id = e.detail.variant.id;

      let product = window.products_json.find(p => p.id == product_id);
      let variant = product.variants.find(v => v.id == variant_id);
      let isSingleVariant = product.variants.length == 1;
      let delivery = isSingleVariant ? product.mf_delivery : variant.mf_delivery;

      let isAvailable = variant.available;
      let isPreorder = variant.available && variant.inventory_quantity <= 0;

      let $section = $form.closest('.product-info') || $form.closest('.quick-buy-drawer');
      $section.querySelectorAll(`.meta-delivery-info[data-product="${ product_id }"]`).forEach(($productDeliveryInfo) => {
        let $deliveryInfo = $productDeliveryInfo.querySelector('.delivery-info');
        if ($deliveryInfo) {
          $deliveryInfo.textContent = delivery;
          $productDeliveryInfo.classList.toggle('hidden', !isPreorder);
        }
      });

      //console.log(product, variant, isPreorder, $section);

      // Button state preorder
      let $atc_btn = $section.querySelector('buy-buttons .button');
      if (!$atc_btn) return;
      let atc_btn_label;
      if (isAvailable) {
         atc_btn_label = window.themeVariables.strings.addToCartButton;
      }
      else {
        atc_btn_label = window.themeVariables.strings.soldOutButton;
      }

      if (isPreorder) {
        atc_btn_label = window.themeVariables.strings.preOrderButton;
      }
      $atc_btn.querySelector('div').textContent = atc_btn_label;

      // capture delivery attribute
      let $atc_form = $atc_btn.closest('form');
      let $hiddenProp = $atc_form.querySelector('.hidden-delivery-prop');
      if (isPreorder) {
        if (delivery) {
          $hiddenProp.setAttribute('name', `properties[${ window.themeVariables.strings.delivery }]`);
          $hiddenProp.value = delivery;  
        }
      }
      else {
        $hiddenProp.removeAttribute('name');
      }
    });   

    // on quickbuy
    document.addEventListener('quickbuy:show', (e) => {
      console.log(e.detail);
      let product = window.products_json[window.products_json.length - 1];
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          product: product,
          variant: product.selected_variant,
          form: e.detail.form
        }
      }));
    });
  }

  const DOMReady = () => {
    DeliveryInfo();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();